'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RoleConfiguration = function () {
  function RoleConfiguration() {
    _classCallCheck(this, RoleConfiguration);
  }

  _createClass(RoleConfiguration, null, [{
    key: 'getRoleConfig',
    value: function getRoleConfig() {
      if (localStorage.getItem('vas_roleConfig')) {
        if (localStorage.getItem('vas_roleConfig').length > 0) {
          var role = JSON.parse(localStorage.getItem('vas_roleConfig'));
          if (role.length > 0) {
            return role;
          } else {
            return [];
          }
        } else {
          return [];
        }
      } else {
        return [];
      }
    }
  }]);

  return RoleConfiguration;
}();

exports.default = RoleConfiguration;